export default __webpack_public_path__ + "static/articulo3-37c20cf82d53feff99ed4656187963b6.png";